import __ from "@feniks-pwa/web-app/web/Layout/Translations";
import {
  FORM_TYPES,
  newDataIsNotSavedText,
} from "@feniks-pwa/web-app/web/Pages/Checkout/Subscription/BenefitSummary/BenefitForm/constants";
import useModalNotification from "@feniks-pwa/web-app/web/hooks/useModalNotification";
import { useField } from "formik";
import { bool, func, string } from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import ChangeDataFormWrapper from "web/Pages/Checkout/Subscription/BenefitSummary/BenefitForm/ChangeDataFormWrapper/changeDataFormWrapper";
import BenefitFormInput from "web/Pages/Checkout/Subscription/BenefitSummary/BenefitForm/benefitFormInput";
import defaultClasses from "web/Pages/Checkout/Subscription/BenefitSummary/BenefitForm/changeReceiverEmailForm.scss";
import { updateDataInDraft } from "web/Pages/Checkout/Subscription/BenefitSummary/BenefitForm/utils";

import { validateRequired } from "web/utils/system/formValidator/rulesValidation";

import { setNotificationError } from "web/features/app/appSlice";

const CheckoutSubscriptionChangeReceiverEmailForm = ({
  formId,
  handleCancelation,
  formUUID,
  benefitUUID,
  onSuccessChanged,
  receiverEmailFieldName,
  emailRepeatedFieldName,
  isMyBenefitsView,
}) => {
  const [, setModalLoaderNotification] = useModalNotification();
  const [initialReceiverEmail, setInitialReceiverEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const [, receiverFieldMeta, receiverFieldHelpers] = useField(
    receiverEmailFieldName
  );
  const [, repeatedFieldMeta, repeatedFieldHelpers] = useField(
    emailRepeatedFieldName
  );

  const receiverEmailValue = receiverFieldMeta?.value;
  const repeatedEmailValue = repeatedFieldMeta?.value;

  useEffect(() => {
    repeatedFieldHelpers.setValue(receiverEmailValue);
    if (!initialReceiverEmail) {
      setInitialReceiverEmail(receiverEmailValue);
    }
  }, []);

  const setFieldError = (field, message) => {
    field.setError(message);
    field.setTouched(true, false);
  };

  const sendReceiverEmail = (activeFormId, newReceiverEmail) => {
    setIsLoading(true);
    if (isMyBenefitsView) setModalLoaderNotification();

    updateDataInDraft(
      benefitUUID,
      {
        id: formUUID,
        receiver: "others",
        receiverEmail: newReceiverEmail,
      },
      FORM_TYPES.ACTIVE_FORMS,
      () => onSuccessChanged(newReceiverEmail),
      () => {
        dispatch(setNotificationError({ message: __(newDataIsNotSavedText) }));
        setIsLoading(false);
      },
      isMyBenefitsView
    );
  };

  const handleChangeEmail = (newValue, repeatedNewValue) => {
    if ([newValue, repeatedNewValue].includes("")) {
      if (newValue === "") {
        setFieldError(receiverFieldHelpers, validateRequired(newValue));
      }
      if (repeatedNewValue === "") {
        setFieldError(repeatedFieldHelpers, validateRequired(repeatedNewValue));
      }
    } else if (newValue === repeatedNewValue) {
      sendReceiverEmail(formId, newValue);
    } else {
      repeatedFieldHelpers.setError(__("Pola muszą być identyczne"));
      repeatedFieldHelpers.setTouched(true, false);
    }
  };

  return (
    <ChangeDataFormWrapper
      onCancelClick={handleCancelation}
      onSendClick={() =>
        handleChangeEmail(receiverEmailValue, repeatedEmailValue)
      }
      areButtonsDisabled={isLoading}
      acceptBtnText="Wyślij"
    >
      <BenefitFormInput
        label={__("Email")}
        name={receiverEmailFieldName}
        disablePaste
      />
      <div className={defaultClasses.repeatedEmailContainer}>
        <BenefitFormInput
          label={__("Powtórz email")}
          name={emailRepeatedFieldName}
          disablePaste
        />
      </div>
    </ChangeDataFormWrapper>
  );
};

CheckoutSubscriptionChangeReceiverEmailForm.propTypes = {
  formId: string.isRequired,
  handleCancelation: func.isRequired,
  formUUID: string.isRequired,
  benefitUUID: string.isRequired,
  onSuccessChanged: func.isRequired,
  receiverEmailFieldName: string.isRequired,
  emailRepeatedFieldName: string.isRequired,
  isMyBenefitsView: bool.isRequired,
};

CheckoutSubscriptionChangeReceiverEmailForm.propTypes = {
  formId: string.isRequired,
  handleCancelation: func.isRequired,
  formUUID: string.isRequired,
  benefitUUID: string.isRequired,
  onSuccessChanged: func.isRequired,
};

export default CheckoutSubscriptionChangeReceiverEmailForm;
